import React, { FunctionComponent } from 'react'

import { DoughnutChart } from './DoughnutChart/DoughnutChart'
import { ChartData } from './IProps'
import { StackedBarChart } from './StackedBarChart/StackedBarChart'
import Style from './style.scss'

const Charts: FunctionComponent<ChartData> = ({
    span,
    chartLabels,
    results,
}) => {
    return (
        <>
            <div className={Style.chartWrapper}>
                <DoughnutChart chartLabels={chartLabels} results={results} />
            </div>
            {/*Something is wrong with the stackedbarchar, complexity also seems to be too high*/}
            {/*{span !== 'week' ? (*/}
            {/*    <div className={Style.chartWrapper}>*/}
            {/*        <StackedBarChart*/}
            {/*            chartLabels={chartLabels}*/}
            {/*            results={results}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*) : null}*/}
        </>
    )
}

export default Charts
